define('modules/lp_integration/models/mdirector_data',['require','exports','module','backbone','env'],function(require,exports,module){
  "use strict";
  var Backbone = require("backbone"),
      config = require("env");

  module.exports = Backbone.Model.extend({
    urlRoot: config.apiHost + "/mdirector/data",
    initialize: function(attrs,options){
      this.lists = new Backbone.Collection();
      this.customFields = [];
    },
    parse: function(json){
      this.lists.reset(json.lists);
      this.customFields = json.customFields;
      this.trigger("change:lists", this, this.lists);
      this.trigger("change:customFields", this, this.customFields);
      module.exports.__super__.parse.call(this, _.omit(json, ["lists", "customFields"]));
    },
    toJSON: function(){
      return {
        lists: this.lists.toJSON(),
        customFields: this.customFields
      };
    }
  });
});
